import * as documentVersionService from "../Services/documents.service";
import {
    addAmendmentStage,
    addVersion,
    fetchCriteriaForAnalysis,
    initialiseAnalysis,
    setIAComments
} from "./stage.action";
import { DocumentActionTypes, IAStreamActionTypes, StageActionTypes } from "./actionTypes";
import { getIAReviewResults } from "../Services/stage.service";
import i18n from "../i18n";
import { message } from "antd";
import {getAnalysisPov, isSamePov} from "../utils/pov";

export const loadVersionContent = (versionId, { refreshAnalysisData = true } = {}) => {
    return async (dispatch, getState) => {
        const expectedCommentsPov = getAnalysisPov(getState().stage?.main_document);
        dispatch(setVersionLoading(true));
        dispatch(setGlobalLoading(true));

        try {
            const content = await documentVersionService.getVersionContent(versionId);
            dispatch(setVersionContent(content.data));
            dispatch(setCurrentVersion(versionId));

            const analyseId = getState().stage?.id;
            const documentId = getState().documentVersion?.currentVersion;
            if (analyseId && refreshAnalysisData) {
                await dispatch(fetchCriteriaForAnalysis(analyseId, documentId));
                const iaCommentsRes = await getIAReviewResults(getState().stage?.id, versionId);
                if (isSamePov(
                    getState().stage?.main_document,
                    expectedCommentsPov,
                )) {
                    dispatch(setIAComments(iaCommentsRes.data));
                }
            }

            dispatch(initialiseAnalysis());

        } catch (error) {
            dispatch(setDocumentError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("referentiel:messages.errorLoading")
            ));
        } finally {
            dispatch(setVersionLoading(false));
            dispatch(setGlobalLoading(false));
        }
    };
};

export const RequestAddVersion = (payload) => {
    return async (dispatch, getState) => {
        dispatch(setVersionLoading(true));
        try {
            const response = await documentVersionService.createVersion(payload);

            const prevVersionId = getState().documentVersion?.currentVersion;
            const returnedId = response.data?.id;
            const isDuplicate = !!(prevVersionId && returnedId && prevVersionId === returnedId);

            if (isDuplicate) {
                message.info(i18n.t("review:version_actions.duplicate"));
                return response;
            }

            const existingMainDocument = getState().stage?.main_document || {};
            const newVersion = {
                ...existingMainDocument,
                id: response.data.id,
                version: response.data.version,
                title: response.data.title,
                created_at: response.data.created_at
            };

            dispatch(addVersion(newVersion, response.data));
            dispatch(setCurrentVersion(newVersion.id));
            dispatch(setVersionContent(response.data));

            const analyseId = getState().stage?.id;
            if (analyseId) {
                dispatch(fetchCriteriaForAnalysis(analyseId, newVersion.id));
            }

            dispatch(setIAComments([]));
            dispatch(initialiseAnalysis());

            message.success(i18n.t("referentiel:messages.versionAdded"));
            return response;
        } catch (error) {
            dispatch(setDocumentError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("referentiel:messages.server")
            ));
            throw error;
        } finally {
            dispatch(setVersionLoading(false));
        }
    };
};


export const RequestAddAmendment = (payload) => {
    return async (dispatch) => {
        try {
            const res = await documentVersionService.createAmendment(payload);
            dispatch(addAmendmentStage(res.data));
            message.success(i18n.t("referentiel:messages.amendmentAdded"));
            return res.data;
        } catch (error) {
            dispatch(setDocumentError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("referentiel:messages.server")
            ));
            throw error;
        }
    };
};


export const RequestUpdateVersionTitle = (versionId, title) => {
    return async (dispatch) => {
        const response = await documentVersionService.updateDocumentVersionTitle(versionId, title);
        const updated = response.data;

        dispatch(setVersionTitle(updated.id || versionId, updated.title));
        return updated;
    };
};



export const setCurrentVersion = (version) => ({
    type: DocumentActionTypes.SET_CURRENT_VERSION,
    payload: version
});

export const setVersionContent = (content) => ({
    type: DocumentActionTypes.SET_VERSION_CONTENT,
    payload: content
});

export const setVersionTitle = (versionId, title) => ({
    type: DocumentActionTypes.SET_VERSION_TITLE,
    payload: { id: versionId, title }
});

export const setVersionLoading = (isLoading) => ({
    type: DocumentActionTypes.SET_VERSION_LOADING,
    payload: isLoading
});

export const setDeletedAmendment = (id_file) => ({
    type: StageActionTypes.REMOVE_STAGE_AMENDMENT,
    payload: id_file
});

export const setGlobalLoading = (isLoading) => ({
    type: DocumentActionTypes.SET_GLOBAL_LOADING,
    payload: isLoading
});

export const setStreamingIa = (isLoading) => ({
    type: IAStreamActionTypes.SET_IA_STREAMING,
    payload: isLoading
});

export const setDocumentError = (errorMessage) => ({
    type: DocumentActionTypes.SET_ERROR,
    payload: errorMessage,
});
